module.exports = __webpack_public_path__ + "img/茂名市科学技术局.6352f516.png";